<template lang="pug">
  v-card.elevation-8
    v-list-item(three-line)
      v-list-item-content
        v-list-item-title.headline.mb-1 {{ name }}
        v-list-item-title.subtitle-1 {{ fullname }}
        v-list-item-title.subtitle-2 {{ role }}
      v-list-item-content.text-right
        div.overline.mb-4 {{ country}}
        v-list-item-title.subtitle-1 {{ height }} cm
        v-list-item-title.subtitle-2 {{ weight }} kg
    v-card-actions
      v-spacer.text-center
        slot
</template>

<script>
  export default {
    name: "PlayerCard",
    props: {
      name: {
        type: String,
        default: ''
      },
      fullname: {
        type: String,
        default: ''
      },
      country: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 0
      },
      weight: {
        type: Number,
        default: 0
      },
      role: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="sass">
</style>